module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\n// prepare usedPermissions\nlet usedPermissions = { read: true, write: true, }\nif(resourceData.usedPermissions){\nusedPermissions = resourceData.usedPermissions\n} else if(resourceData.permissions){\nusedPermissions = {\nread: \tutils.permissions.hasAccessTo(storage, resourceData.permissions, 'read', scope, 'cms_media'),\nwrite: \tutils.permissions.hasAccessTo(storage, resourceData.permissions, 'write', scope, 'cms_media'),\n}\n}\nconst additionalClasses = []\nif(usedPermissions.read){\nif(resourceData.isNew)  additionalClasses.push('isNew');\n}\nif(resourceData.delete)             additionalClasses.push('delete');\nelse if (resourceData.renew)        additionalClasses.push('renew');\nelse if(resourceData.pause)         additionalClasses.push('pause');\nif(usedPermissions.read && ((resourceData.permissions || {}).public || {}).read === false){\nadditionalClasses.push('isRestricted')\n}\nif(!resourceData.isReusable){\nadditionalClasses.push('isNonReusable')\n}\nlet imageTitle = ''\nif(model.extendedButtonActionsGranted){\nimageTitle = '# ' + (resourceData.mediaID || '') + ' - '\n}\nif(resourceData.missingMainDBEntry) {\nimageTitle += storage.__('error:imageManagement.missingMainDBEntry.title')\nadditionalClasses.push('missingMainDBEntry')\n} else if(!usedPermissions.read){\nimageTitle += storage.__('error:imageManagement.permissionsDenied.title')\nadditionalClasses.push('permissionsDenied')\n} else if(!resourceData.mediaID) {\nimageTitle = storage.__('hint.imageField.placeholder')\nadditionalClasses.push('placeholder')\n} else {\nimageTitle += (resourceData.url || '')\n}\nlet imageWidth, imageHeight\nconst resourceWidth = resourceData.preferredWidth || resourceData.width\nconst resourceHeight = resourceData.preferredHeight || resourceData.height\nif(resourceWidth && resourceHeight){\nif(resourceWidth > resourceHeight){\nimageWidth = model.maxImageWidth || 100\nimageHeight = resourceHeight * imageWidth / resourceWidth\n} else {\nimageHeight = model.maxImageHeight || 100\nimageWidth = resourceWidth * imageHeight / resourceHeight\n}\n} else {\nimageWidth = model.maxImageWidth || 100\nimageHeight = model.maxImageHeight || 100\n}\nlet controls = {\ncopyToClipboardUrl: usedPermissions.read && !config.slimControls,\nassignTags:         usedPermissions.write && !config.slimControls,\nedit:               usedPermissions.write && config.context === 'assignment' && !config.slimControls,\nrenew:              usedPermissions.write && config.context === 'assignment' && model.extendedButtonActionsGranted,\npause:              usedPermissions.write && config.context === 'assignment' && !config.slimControls,\ndelete:             usedPermissions.write,\n}\nif(resourceData.missingMainDBEntry) {\ncontrols = {\ndelete: usedPermissions.write\n}\n} else {\nif(config.controls === false){\ncontrols = false\n}\nelse {\nfor(var command in config.controls){\nif(config.controls[command] === false){\ncontrols[command] = false\n}\n}\n}\n}\n// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.\nconst url     = resourceData.preferredUrl || resourceData.url || ''\nconst thumb   = resourceData.preferredThumb || resourceData.thumb || ''\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-media-id=\"<%- resourceData.mediaID %>\" data-media-rendered-id=\"<%- resourceData.mediaRenderedID %>\" data-media-index=\"<%- resourceData.index %>\" title=\"<%= imageTitle %>\"><%\nif(controls){\n%><div class=\"controls\"><%\nif(controls.copyToClipboardUrl){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl',  context: 'media-image', mode: config.context, symbolOnly: true, icon: 'fi fi-copy-to-clipboard' } }) %><%\n}\nif(controls.assignTags){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign',          context: 'tags',        mode: config.context, symbolOnly: true, icon: 'fi fi-mediaImageDetails' } }) %><%\n}\nif(controls.edit){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'showEdit',            context: 'media-image', mode: config.context, symbolOnly: true } }) %><%\n}\nif(controls.renew){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'renew',               context: 'media-image', mode: config.context, symbolOnly: true } }) %><%\n}\nif(controls.pause){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'pause',               context: 'media-image', mode: config.context, symbolOnly: true } }) %><%\n}\nif(controls.delete){\n%><%- include('../../elements/buttons/default', { formMapping: { buttonType: 'delete',              context: 'media-image', mode: config.context, symbolOnly: true } }) %><%\n}\n%></div><%\n}\nif(resourceData.missingMainDBEntry){\n%><i class=\"missingMainDBEntrySymbol fi fi-exclamation-triangle\" title=\"<%= imageTitle %>\"></i><%\n} else if(!usedPermissions.read){\n%><i class=\"permissionsDeniedSymbol fi fi-shield\" title=\"<%= imageTitle %>\"></i><%\n} else if(resourceData.fileType === 'file' && resourceData.extension) {\n%><i class=\"fi fi-media-<%= String(resourceData.extension).toLowerCase() %>\" title=\"<%= imageTitle %>\"></i><%\n} else if(!resourceData.mediaID) {\n%><i class=\"fi fi-media-placeholder\" title=\"<%= imageTitle %>\"></i><%\n} else {\n%><img title=\"<%= imageTitle %>\" alt=\"<%- resourceData.mediaID %>\" src=\"<%- thumb %>\" width=\"<%= imageWidth %>px\" height=\"<%= imageHeight %>px\"/><%\n}\n%>\n<div class=\"restricted\">\n<i class=\"fi fi-shield\"></i>\n</div>\n<div class=\"nonReusable\">\n<i class=\"fi fi-coffee\"></i>\n</div>\n<div class=\"new\">\n<i class=\"fi fi-image-new\"></i>\n</div>\n<div class=\"status\">\n<i class=\"pause fi fi-pause\"></i>\n<i class=\"renew fi fi-refresh\"></i>\n<i class=\"delete fi fi-trash\"></i>\n</div>\n<%\nif(config.additionalDataInclusionTemplate){\n%><%- include(config.additionalDataInclusionTemplate, { resourceData: resourceData }) %><%\n}\n%></div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\media\\image\\image.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
// prepare usedPermissions
let usedPermissions = { read: true, write: true, }
if(resourceData.usedPermissions){
usedPermissions = resourceData.usedPermissions
} else if(resourceData.permissions){
usedPermissions = {
read: 	utils.permissions.hasAccessTo(storage, resourceData.permissions, 'read', scope, 'cms_media'),
write: 	utils.permissions.hasAccessTo(storage, resourceData.permissions, 'write', scope, 'cms_media'),
}
}
const additionalClasses = []
if(usedPermissions.read){
if(resourceData.isNew)  additionalClasses.push('isNew');
}
if(resourceData.delete)             additionalClasses.push('delete');
else if (resourceData.renew)        additionalClasses.push('renew');
else if(resourceData.pause)         additionalClasses.push('pause');
if(usedPermissions.read && ((resourceData.permissions || {}).public || {}).read === false){
additionalClasses.push('isRestricted')
}
if(!resourceData.isReusable){
additionalClasses.push('isNonReusable')
}
let imageTitle = ''
if(model.extendedButtonActionsGranted){
imageTitle = '# ' + (resourceData.mediaID || '') + ' - '
}
if(resourceData.missingMainDBEntry) {
imageTitle += storage.__('error:imageManagement.missingMainDBEntry.title')
additionalClasses.push('missingMainDBEntry')
} else if(!usedPermissions.read){
imageTitle += storage.__('error:imageManagement.permissionsDenied.title')
additionalClasses.push('permissionsDenied')
} else if(!resourceData.mediaID) {
imageTitle = storage.__('hint.imageField.placeholder')
additionalClasses.push('placeholder')
} else {
imageTitle += (resourceData.url || '')
}
let imageWidth, imageHeight
const resourceWidth = resourceData.preferredWidth || resourceData.width
const resourceHeight = resourceData.preferredHeight || resourceData.height
if(resourceWidth && resourceHeight){
if(resourceWidth > resourceHeight){
imageWidth = model.maxImageWidth || 100
imageHeight = resourceHeight * imageWidth / resourceWidth
} else {
imageHeight = model.maxImageHeight || 100
imageWidth = resourceWidth * imageHeight / resourceHeight
}
} else {
imageWidth = model.maxImageWidth || 100
imageHeight = model.maxImageHeight || 100
}
let controls = {
copyToClipboardUrl: usedPermissions.read && !config.slimControls,
assignTags:         usedPermissions.write && !config.slimControls,
edit:               usedPermissions.write && config.context === 'assignment' && !config.slimControls,
renew:              usedPermissions.write && config.context === 'assignment' && model.extendedButtonActionsGranted,
pause:              usedPermissions.write && config.context === 'assignment' && !config.slimControls,
delete:             usedPermissions.write,
}
if(resourceData.missingMainDBEntry) {
controls = {
delete: usedPermissions.write
}
} else {
if(config.controls === false){
controls = false
}
else {
for(var command in config.controls){
if(config.controls[command] === false){
controls[command] = false
}
}
}
}
// NOTE: usually no testing on urls is necessary - but the cms-should be robust and stable even in error cases.
const url     = resourceData.preferredUrl || resourceData.url || ''
const thumb   = resourceData.preferredThumb || resourceData.thumb || ''

    ; __line = 83
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-media-id=\"")
    ; __append( resourceData.mediaID )
    ; __append("\" data-media-rendered-id=\"")
    ; __append( resourceData.mediaRenderedID )
    ; __append("\" data-media-index=\"")
    ; __append( resourceData.index )
    ; __append("\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\">")
    ; 
if(controls){

    ; __line = 85
    ; __append("<div class=\"controls\">")
    ; 
if(controls.copyToClipboardUrl){

    ; __line = 87
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'copyToClipboardUrl',  context: 'media-image', mode: config.context, symbolOnly: true, icon: 'fi fi-copy-to-clipboard' } }) )
    ; 
}
if(controls.assignTags){

    ; __line = 90
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'showAssign',          context: 'tags',        mode: config.context, symbolOnly: true, icon: 'fi fi-mediaImageDetails' } }) )
    ; 
}
if(controls.edit){

    ; __line = 93
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'showEdit',            context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; 
}
if(controls.renew){

    ; __line = 96
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'renew',               context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; 
}
if(controls.pause){

    ; __line = 99
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'pause',               context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; 
}
if(controls.delete){

    ; __line = 102
    ; __append( include('../../elements/buttons/default', { formMapping: { buttonType: 'delete',              context: 'media-image', mode: config.context, symbolOnly: true } }) )
    ; 
}

    ; __line = 104
    ; __append("</div>")
    ; 
}
if(resourceData.missingMainDBEntry){

    ; __line = 107
    ; __append("<i class=\"missingMainDBEntrySymbol fi fi-exclamation-triangle\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\"></i>")
    ; 
} else if(!usedPermissions.read){

    ; __line = 109
    ; __append("<i class=\"permissionsDeniedSymbol fi fi-shield\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\"></i>")
    ; 
} else if(resourceData.fileType === 'file' && resourceData.extension) {

    ; __line = 111
    ; __append("<i class=\"fi fi-media-")
    ; __append(escapeFn( String(resourceData.extension).toLowerCase() ))
    ; __append("\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\"></i>")
    ; 
} else if(!resourceData.mediaID) {

    ; __line = 113
    ; __append("<i class=\"fi fi-media-placeholder\" title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\"></i>")
    ; 
} else {

    ; __line = 115
    ; __append("<img title=\"")
    ; __append(escapeFn( imageTitle ))
    ; __append("\" alt=\"")
    ; __append( resourceData.mediaID )
    ; __append("\" src=\"")
    ; __append( thumb )
    ; __append("\" width=\"")
    ; __append(escapeFn( imageWidth ))
    ; __append("px\" height=\"")
    ; __append(escapeFn( imageHeight ))
    ; __append("px\"/>")
    ; 
}

    ; __line = 117
    ; __append("\n<div class=\"restricted\">\n<i class=\"fi fi-shield\"></i>\n</div>\n<div class=\"nonReusable\">\n<i class=\"fi fi-coffee\"></i>\n</div>\n<div class=\"new\">\n<i class=\"fi fi-image-new\"></i>\n</div>\n<div class=\"status\">\n<i class=\"pause fi fi-pause\"></i>\n<i class=\"renew fi fi-refresh\"></i>\n<i class=\"delete fi fi-trash\"></i>\n</div>\n")
    ; __line = 132
    ; 
if(config.additionalDataInclusionTemplate){

    ; __line = 134
    ; __append( include(config.additionalDataInclusionTemplate, { resourceData: resourceData }) )
    ; 
}

    ; __line = 136
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\media\image\image.ejs

}